import React from "react";

export default function About() {
  return (
    <React.Fragment>
      <h1>About</h1>
      <h4>TodoList v1.0.0, Brandon Ho July 2020</h4>
      <p>
        This is a simple Todo List created based on a React crash course by
        Traversy Media
      </p>
    </React.Fragment>
  );
}
